import React, {useEffect, useState} from "react";

import axios from "config/axiosConfig";
import {useLocation, useNavigate} from "react-router-dom";
import DatePicker from "react-datepicker";
import dateFormat, { masks } from "dateformat";
import 'react-datepicker/dist/react-datepicker.css';

export default function Detail() {
    const [content, setContent] = useState();

    const [handleTitle, setHandleTitle] = useState();
    const [handleLinkUrl, setHandleLinkUrl] = useState();
    const [handleIsShow, setHandleIsShow] = useState(true);


    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search); // 쿼리 파라미터 추출
    const id = queryParams.get("id");

    const requestData = () => {
        if (id !== null && id !== "") {
            axios.get(`/admin/notices/${id}`)
                .then((res) => {
                    setContent(res.data);
                    setHandleTitle(res.data.title);
                    setHandleLinkUrl(res.data.linkUrl);
                    setHandleIsShow(res.data.isShow ?? true);
                });
        }
    }

    const requestSave = () => {
        (async () => {
            const params = {
                title: handleTitle,
                linkUrl: handleLinkUrl,
                isShow: handleIsShow,
            }

            const config = {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            };

            try {
                let savedRes;
                if (id !== null && id !== "") {
                    savedRes = await axios.put(`/admin/notices/${id}`, params, config);
                } else {
                    savedRes = await axios.post(`/admin/notices`, params, config);
                }

                if (savedRes.status === 200) {
                    alert('저장 되었습니다.');
                    navigate(-1);
                }
            } catch (err) {
                console.error(err);
                alert('저장 중 오류가 발생했습니다.');
            }
        })();
    }

    useEffect(() => {
        requestData()
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">메인화면-공지사항 상세</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="card card-secondary col-sm-12">
                                    <div className="card-body">

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label htmlFor="input-sub-title"
                                                   className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>제목</label>
                                            <div className="col-sm-10">
                                                <input id="input-link-url"
                                                       type="text"
                                                       className="form-control"
                                                       onChange={event => {
                                                           setHandleTitle(event.target.value);
                                                       }}
                                                       value={handleTitle ?? ""}
                                                />
                                            </div>
                                        </div>

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label htmlFor="input-sub-title"
                                                   className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>링크</label>
                                            <div className="col-sm-10">
                                                <input id="input-link-url"
                                                       type="text"
                                                       className="form-control"
                                                       onChange={event => {
                                                           setHandleLinkUrl(event.target.value);
                                                       }}
                                                    value={handleLinkUrl ?? ""}
                                                />
                                            </div>
                                        </div>

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label htmlFor="input-is-show"
                                                   className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>노출</label>
                                            <div className="col-sm-10" style={{display: "flex", alignItems: "center"}}>
                                                <input id="input-is-show"
                                                       type="checkbox"
                                                       style={{transform: "scale(1.2)", marginRight: "8px"}}
                                                       checked={handleIsShow}
                                                       onChange={event => {
                                                           setHandleIsShow(event.target.checked);
                                                       }}
                                                />
                                                <span>{handleIsShow ? "ON" : "OFF"}</span>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <div className="row">
                        <div style={{margin: "0 auto"}}>
                            <button type="button" className="btn btn-outline-secondary"
                                    onClick={event => {navigate(-1)}}>
                                목록
                            </button>
                            <button type="button" className="btn btn-outline-primary"
                                    style={{marginLeft: "10px"}}
                                    onClick={requestSave}>
                                {id === null ? '저장' : '수정'}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
